import { QueryKeys } from "@app/constants/query-keys.ts";
import { useApis } from "@app/data/apis.ts";
import { SystemInfoPostModel } from "@app/data/engine.ts";
import { handleApiError } from "@app/helpers/error-helper.tsx";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useQuery } from "bi-lib";
import { toast } from "react-toastify";

export default function useSetupSystemInfoData() {
    const apis = useApis();
    const queryClient = useQueryClient();

    const getSystemInfoQuery = useQuery({
        queryKey: [QueryKeys.GetSystemInfo],
        queryFn: () => apis.engine.setupApi.setupApiGetSystemInfoList(),
    });

    const saveSystemInfoMutation = useMutation({
        mutationFn: (post: SystemInfoPostModel) => apis.engine.setupApi.setupApiSaveSystemInfoCreate(post),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [QueryKeys.GetSystemInfo] });
            toast.success("System info saved");
        },
        onError: (error: Error) => handleApiError(error, "Failed to save system info"),
    });

    return {
        systemInfo: getSystemInfoQuery,

        saveSystemInfo: saveSystemInfoMutation,
    };
}
